import React from 'react';
import CategoriesList from 'src/components/categories-list';
import { MainDispensaryLayout } from 'src/components/layouts/main-dispensary-layout';
import { withLayout } from 'src/components/layouts/with-layout';
import { getCacheableSearchVisibilityServerSideProps } from 'src/utils/ssr/get-dispensary-server-side-props';

export const getServerSideProps = getCacheableSearchVisibilityServerSideProps;

function CategoriesPage() {
  return <CategoriesList />;
}

export default withLayout(CategoriesPage, MainDispensaryLayout);
